import { z } from 'zod'

export const CategoryFormSchema = z.object({
  name: z.string().min(1, {
    message: 'catalog.categories.form.name.required',
  }),
  parentId: z.string().nullable().optional(),
  // externalId: z.string().nullable().optional(),
  position: z.number().nullable().optional(),
})

export type CategoryFormValues = z.infer<typeof CategoryFormSchema>

